exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#add-piece{background-color:#5698d2;color:#fff;width:230px;margin:15px 0;padding-left:15px}.add-piece-swal label{text-align:left}li.piece{display:flex;border-bottom:1px solid #ccc;padding:15px 0;flex-direction:row;align-items:center;justify-content:space-between;font-size:1.5rem}li.piece:last-child{border-bottom:none}li.piece .price{margin-left:auto;background-color:#ccc;border-radius:5px;padding:5px}li.piece a.delete{margin-left:15px;width:40px;height:40px;color:#fff;background-color:#c31616}li.piece a.delete i{font-size:2.3rem;width:38px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31b59ee1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/subcomponents/GestionPieces.vue
// module id = 622
// module chunks = 0